'use client';

import { SessionProvider } from 'next-auth/react';

import { ModalProvider } from '@/context/ModalContext';
import { ReportProvider } from '@/context/ReportContext';
import { LocalizationProvider } from '@/context/LocalizationContext';
import { UserProvider } from '@/context/UserContext';

export function Providers({ children }) {
  return (
    <SessionProvider>
      <UserProvider>
        <ModalProvider>
          <LocalizationProvider>
            <ReportProvider>{children}</ReportProvider>
          </LocalizationProvider>
        </ModalProvider>
      </UserProvider>
    </SessionProvider>
  );
}
